const landcoverData = [
  { label: 'water', color: 'rgba(0,100,200, 0.8)' },
  { label: 'trees', color: 'rgba(0,100,0, 0.8)' },
  { label: 'grass', color: 'rgba(255, 255, 76, 0.8)' },
  { label: 'herbaceous wetland', color: 'rgba(0, 150, 160, 0.8)' },
  { label: 'mangroves', color: 'rgba(0, 207, 117, 0.8)' },
  { label: 'crops', color: 'rgba(240, 150, 255, 0.8)' },
  { label: 'shrubland', color: 'rgba(255, 187, 34, 0.8)' },
  { label: 'built-up', color: 'rgba(250, 0, 0, 0.8)' },
  { label: 'bare/sparse vegetation', color: 'rgba(180, 180, 180, 0.8)' },
  { label: 'moss & lichen', color: 'rgba(250, 230, 160, 0.8)' },
  { label: 'snow/ice', color: 'rgba(240, 240, 240, 0.8)' },
  { label: 'no data', color: 'rgba(255, 255, 255, 0.8)' },
]

export {
  landcoverData,
}
